export const en = {
    roles: {
        list: {
            id: "ID",
            name: "Name",
            entity: "Entity",
        },
        alerts: {
            create: {
                title: "Create Role",
                text: "Are you sure you want to create <b>%{role}</b>",
                success: {
                    title: "Role Created Successfully",
                    text: "<b>%{role}</b> was created successfully",
                },
                error: {
                    title: "Role Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Role",
                text: "Are you sure you want to delete <b>%{role}</b>",
                success: {
                    title: "Role Deleted Successfully",
                    text: "You will now be redirected to the roles page",
                },
                error: {
                    title: "Role Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Role",
                text: "Are you sure you want to edit <b>%{role}</b>",
                success: {
                    title: "Role Edited Successfully",
                    text: "<b>%{role}</b> was edited successfully",
                },
                error: {
                    title: "Role Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        form: {
            headers: {
                create: "Create Role",
                edit: "Edit Role",
                view: "View Role"
            },
            name: {
                label: "Name",
            },
            entity: {
                label: "Entity",
            },
            permissions: "Permissions"
        },
        search: {
            name: "Name",
            entity: "Entity"
        },
        permissions: {
            ROLES: "Roles",
            CREATE_ROLE: "Create roles",
            READ_ROLE: "Read roles",
            UPDATE_ROLE: "Update roles",
            DELETE_ROLE:"Delete roles"
        },
        errors: {
            roleNameAlreadyExists: 'Role name already exists. Change it and try again.',
            roleHasUsersAssigned: 'Role has users assigned. Reversing operation.'
        }
    },
    root: {
        permissions: {
            ROOT: "Root",
        }
    }
};